import React, { ReactElement, useEffect, useRef, useState } from "react";
import '../lib/Button.css'

interface ButtonProps {
    logo?: ReactElement,
    title?: string,
    btnType?: 'danger' | 'filled' | 'default' | 'hidden' | 'transparent' | 'price'
    btnSize?: 'base' | 'xs' | 'xl' | 'lg' | 'adaptive'
    stylesContainer?: React.CSSProperties,
    stylesButton?: React.CSSProperties,
    stylesLogo?: React.CSSProperties,
    stylesTitle?: React.CSSProperties,
    loading?: boolean,
    disabled?: boolean,
    typeOfAction?: 'submit' | 'button' | 'reset'
    onClickFunc?: Function,
    showPicked?: 'fill' | 'colored' | 'none',
    focusInitial?: boolean
}

export const Button = ({logo, title, btnType, btnSize, stylesContainer, stylesLogo, stylesTitle, loading, disabled, typeOfAction='button', onClickFunc, showPicked, focusInitial, stylesButton}: ButtonProps) => {
    const [widthOfContent, setWidthOfContent] = useState<number>();
    const btnRef = useRef<HTMLButtonElement>(null)

    if (btnRef.current) {
        if (focusInitial) {
            btnRef.current.focus()
        }
    }

    useEffect(() => {
        const updateWidth = () => {
            if (btnRef.current) {
              setWidthOfContent(btnRef.current.offsetWidth);
            }
          };
      
          updateWidth();      
          window.addEventListener('resize', updateWidth);
      
          return () => {
            window.removeEventListener('resize', updateWidth);
          };
    })

    return (
        <button type={typeOfAction} ref={btnRef} className={`button ${btnType ?? 'default'} ${btnSize ?? 'base'} ${showPicked ? `picked ${showPicked}` : null}`} 
            style={{ ...stylesButton, ...(loading ? {width: `${widthOfContent}px`} : !logo ? {justifyContent: 'center'} : {}) }}
            onClick={(e: any) => { e.stopPropagation() 
                                    e.preventDefault()
                                    onClickFunc && onClickFunc()}} 
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            aria-label={loading ? title : undefined}>
            {loading ? 
                <div className="loaderBtn" /> :
                <span className="button__container" style={stylesContainer}>
                    { logo && <span className="button__logo" style={stylesLogo}>{logo}</span> }
                    
                    <p className='button__title' style={stylesTitle}>{title ?? 'Кнопка'}</p>
                </span>
            }   
        </button>
    )

}
